/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TransacaoResponse } from '../models/transacao-response';
import { TransacaoCredito } from '../models/transacao-credito';
import { TransacaoCreditoPaginado } from '../models/transacao-credito-paginado';
import { Message } from '../models/message';
import { RequestValidarTransacaoType } from '../models/request-validar-transacao-type';
import { RequestRecusarTransacaoType } from '../models/request-recusar-transacao-type';

/**
 * API responsavel pelos dados da transação-credito
 */
@Injectable({
  providedIn: 'root',
})
class TransacaoCreditoService extends __BaseService {
  static readonly conciliarPath = '/transacao-credito';
  static readonly obterTransacoesPath = '/transacao-credito';
  static readonly obterTransacaoPorNumeroPath = '/transacao-credito/{numeroTransacao}';
  static readonly validarTransacaoPath = '/transacao-credito/validar-transacao';
  static readonly recusarTransacaoPath = '/transacao-credito/recusar-transacao';
  static readonly atualizarStatusTransacaoPath = '/transacao-credito/atualizar-status-transacao';
  static readonly obterComprovanteTransacaoPath = '/transacao-credito/comprovante/{idArquivoComprovante}';
  static readonly cancelarTransacaoPath = '/transacao-credito/cancelar-transacao';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Cadastra uma transacao
   * @param transacaoCredito Objeto da transação
   * @return Operacao realizada com sucesso
   */
  conciliarResponse(transacaoCredito: TransacaoCredito): __Observable<__StrictHttpResponse<TransacaoResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = transacaoCredito;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/transacao-credito`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TransacaoResponse>;
      })
    );
  }
  /**
   * Cadastra uma transacao
   * @param transacaoCredito Objeto da transação
   * @return Operacao realizada com sucesso
   */
  conciliar(transacaoCredito: TransacaoCredito): __Observable<TransacaoResponse> {
    return this.conciliarResponse(transacaoCredito).pipe(
      __map(_r => _r.body as TransacaoResponse)
    );
  }

  /**
   * Recupera uma listagem das transações com base nos parametros informados
   * @param params The `TransacaoCreditoService.ObterTransacoesParams` containing the following parameters:
   *
   * - `valorInicial`: Faixa de valor inicial na pesquisa
   *
   * - `valorFinal`: Faixa de valor final na pesquisa
   *
   * - `sequenciaItemSinistro`: Numero sequencial do item do sinistro
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroTransacao`: Numero da transacao
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `codigoStatus`: Codigo do status da linha de extrato
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `codigoContaCredito`: Codigo da conta de credito
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterTransacoesResponse(params: TransacaoCreditoService.ObterTransacoesParams): __Observable<__StrictHttpResponse<TransacaoCreditoPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.valorInicial != null) __params = __params.set('valorInicial', params.valorInicial.toString());
    if (params.valorFinal != null) __params = __params.set('valorFinal', params.valorFinal.toString());
    if (params.sequenciaItemSinistro != null) __params = __params.set('sequenciaItemSinistro', params.sequenciaItemSinistro.toString());
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.perPage != null) __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.numeroTransacao != null) __params = __params.set('numeroTransacao', params.numeroTransacao.toString());
    if (params.numeroSinistro != null) __params = __params.set('numeroSinistro', params.numeroSinistro.toString());
    if (params.codigoStatus != null) __params = __params.set('codigoStatus', params.codigoStatus.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    if (params.codigoContaCredito != null) __params = __params.set('codigoContaCredito', params.codigoContaCredito.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/transacao-credito`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TransacaoCreditoPaginado>;
      })
    );
  }
  /**
   * Recupera uma listagem das transações com base nos parametros informados
   * @param params The `TransacaoCreditoService.ObterTransacoesParams` containing the following parameters:
   *
   * - `valorInicial`: Faixa de valor inicial na pesquisa
   *
   * - `valorFinal`: Faixa de valor final na pesquisa
   *
   * - `sequenciaItemSinistro`: Numero sequencial do item do sinistro
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroTransacao`: Numero da transacao
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `codigoStatus`: Codigo do status da linha de extrato
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `codigoContaCredito`: Codigo da conta de credito
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterTransacoes(params: TransacaoCreditoService.ObterTransacoesParams): __Observable<TransacaoCreditoPaginado> {
    return this.obterTransacoesResponse(params).pipe(
      __map(_r => _r.body as TransacaoCreditoPaginado)
    );
  }

  /**
   * Recupera uma listagem das transações com base nos parametros informados
   * @param numeroTransacao Codigo identificador da transação
   * @return Operacao realizada com sucesso
   */
  obterTransacaoPorNumeroResponse(numeroTransacao: number): __Observable<__StrictHttpResponse<TransacaoCredito>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/transacao-credito/${encodeURIComponent(String(numeroTransacao))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TransacaoCredito>;
      })
    );
  }
  /**
   * Recupera uma listagem das transações com base nos parametros informados
   * @param numeroTransacao Codigo identificador da transação
   * @return Operacao realizada com sucesso
   */
  obterTransacaoPorNumero(numeroTransacao: number): __Observable<TransacaoCredito> {
    return this.obterTransacaoPorNumeroResponse(numeroTransacao).pipe(
      __map(_r => _r.body as TransacaoCredito)
    );
  }

  /**
   * Valida uma transacao
   * @param RequestValidarTransacaoType Informacoes da transação a ser validada
   * @return Operacao realizada com sucesso
   */
  validarTransacaoResponse(RequestValidarTransacaoType: RequestValidarTransacaoType): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = RequestValidarTransacaoType;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/transacao-credito/validar-transacao`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Valida uma transacao
   * @param RequestValidarTransacaoType Informacoes da transação a ser validada
   * @return Operacao realizada com sucesso
   */
  validarTransacao(RequestValidarTransacaoType: RequestValidarTransacaoType): __Observable<Message> {
    return this.validarTransacaoResponse(RequestValidarTransacaoType).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Recusar uma transacao
   * @param RequestRecusarTransacaoType Informacoes da transação a ser reprovada
   * @return Operacao realizada com sucesso
   */
  recusarTransacaoResponse(RequestRecusarTransacaoType: RequestRecusarTransacaoType): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = RequestRecusarTransacaoType;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/transacao-credito/recusar-transacao`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Recusar uma transacao
   * @param RequestRecusarTransacaoType Informacoes da transação a ser reprovada
   * @return Operacao realizada com sucesso
   */
  recusarTransacao(RequestRecusarTransacaoType: RequestRecusarTransacaoType): __Observable<Message> {
    return this.recusarTransacaoResponse(RequestRecusarTransacaoType).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Atualizar uma transacao
   * @param transacaoCredito Objeto da transacao
   * @return Operacao realizada com sucesso
   */
  atualizarStatusTransacaoResponse(transacaoCredito: TransacaoCredito): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = transacaoCredito;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/transacao-credito/atualizar-status-transacao`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Atualizar uma transacao
   * @param transacaoCredito Objeto da transacao
   * @return Operacao realizada com sucesso
   */
  atualizarStatusTransacao(transacaoCredito: TransacaoCredito): __Observable<Message> {
    return this.atualizarStatusTransacaoResponse(transacaoCredito).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Retorna comprovante da transacao
   * @param idArquivoComprovante Codigo identificador do arquivo
   * @return Arquivo encontrado
   */
  obterComprovanteTransacaoResponse(idArquivoComprovante: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/transacao-credito/comprovante/${encodeURIComponent(String(idArquivoComprovante))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Retorna comprovante da transacao
   * @param idArquivoComprovante Codigo identificador do arquivo
   * @return Arquivo encontrado
   */
  obterComprovanteTransacao(idArquivoComprovante: string): __Observable<Blob> {
    return this.obterComprovanteTransacaoResponse(idArquivoComprovante).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * Reprova uma transacao
   * @param RequestRecusarTransacaoType Informacoes da transação a ser cancelada
   * @return Operacao realizada com sucesso
   */
  cancelarTransacaoResponse(RequestRecusarTransacaoType: RequestRecusarTransacaoType): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = RequestRecusarTransacaoType;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/transacao-credito/cancelar-transacao`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Reprova uma transacao
   * @param RequestRecusarTransacaoType Informacoes da transação a ser cancelada
   * @return Operacao realizada com sucesso
   */
  cancelarTransacao(RequestRecusarTransacaoType: RequestRecusarTransacaoType): __Observable<Message> {
    return this.cancelarTransacaoResponse(RequestRecusarTransacaoType).pipe(
      __map(_r => _r.body as Message)
    );
  }
}

module TransacaoCreditoService {

  /**
   * Parameters for obterTransacoes
   */
  export interface ObterTransacoesParams {

    /**
     * Faixa de valor inicial na pesquisa
     */
    valorInicial?: number;

    /**
     * Faixa de valor final na pesquisa
     */
    valorFinal?: number;

    /**
     * Numero sequencial do item do sinistro
     */
    sequenciaItemSinistro?: number;

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Quantidade registros por pagina
     */
    perPage?: number;

    /**
     * Pagina inicial
     */
    page?: number;

    /**
     * Numero da transacao
     */
    numeroTransacao?: number;

    /**
     * Numero do sinistro
     */
    numeroSinistro?: number;

    /**
     * Codigo do status da linha de extrato
     */
    codigoStatus?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;

    /**
     * Codigo da conta de credito
     */
    codigoContaCredito?: number;

    /**
     * Ano do sinistro
     */
    anoSinistro?: number;
  }
}

export { TransacaoCreditoService }
